import React from 'react';
import { motion } from 'framer-motion';
import { Star, Heart } from 'lucide-react';
const testimonials = [{
  initial: 'P',
  color: 'bg-pink-100 text-pink-700',
  name: 'Patricia O.',
  location: 'Córdoba',
  plan: 'Plan Premium',
  text: 'Mi hija lloraba cada vez que yo sacaba el libro. Literalmente lloraba antes de empezar. Hoy — y esto me cuesta creerlo mientras lo escribo — ella me pide que leamos juntos antes de dormir. Eso no tiene precio.'
}, {
  initial: 'H',
  color: 'bg-blue-100 text-blue-700',
  name: 'Hernán G.',
  location: 'Rosario',
  plan: 'Plan Base',
  text: 'Pagué $8.000 por sesión con una fonoaudióloga durante 6 meses. Mejoró algo pero nunca terminamos de resolver el silabeo. Con el Tomo 3 en tres semanas logré más que en esos 6 meses. No lo digo para criticar a nadie — lo digo porque este método funciona diferente.'
}, {
  initial: 'S',
  color: 'bg-emerald-100 text-emerald-700',
  name: 'Sebastián R.',
  location: 'La Plata',
  plan: 'Plan Base',
  text: 'Lo que más me cambió no fue el método de lectura. Fue el Bono 2. Aprender qué decir cuando se frustra transformó completamente nuestra dinámica. Ya no termino las sesiones sintiéndome mal padre.'
}];
export function TestimonialsBottom() {
  return <section className="py-12 md:py-16 bg-slate-50" data-id="element-285">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-286">
        <div className="text-center mb-8 flex flex-col items-center" data-id="element-287">
          <Heart className="w-8 h-8 text-red-500 mb-4 fill-current" data-id="element-288" />
          <h2 className="text-3xl font-bold text-navy" data-id="element-289">
            MÁS PADRES QUE YA LO TIENEN
          </h2>
        </div>

        <div className="space-y-6" data-id="element-290">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white rounded-2xl p-8 shadow-lg shadow-slate-200/50 border border-slate-100" data-id="element-291">
              <div className="flex text-gold mb-4" data-id="element-292">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-293" />)}
              </div>

              <p className="text-slate-700 text-lg leading-relaxed mb-6 italic" data-id="element-294">
                "{t.text}"
              </p>

              <div className="flex items-center justify-between border-t border-slate-100 pt-4" data-id="element-295">
                <div className="flex items-center" data-id="element-296">
                  <div className={`w-10 h-10 rounded-full flex items-center justify-center font-bold ${t.color} mr-3`} data-id="element-297">
                    {t.initial}
                  </div>
                  <div data-id="element-298">
                    <div className="font-bold text-navy text-sm" data-id="element-299">{t.name}</div>
                    <div className="text-xs text-slate-500" data-id="element-300">
                      📍 {t.location}
                    </div>
                  </div>
                </div>
                <div className="bg-slate-100 text-slate-600 text-xs font-bold px-3 py-1 rounded-full" data-id="element-301">
                  {t.plan}
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}